var React = require('react');

function WindowsLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8 12.767 13.086-1.79V23.58H8V12.767zm14.662-2.046L40 8.201v15.27H22.662V10.72zM8 24.91h13.086v12.64L8 35.722V24.91zm14.662.168H40v15.124l-17.338-2.448V25.077z","fill":"#fff","opacity":".5"}));
}

WindowsLogo.defaultProps = {"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none"};

module.exports = WindowsLogo;

WindowsLogo.default = WindowsLogo;
